<template>
  <div class="login">
    <main>
      <div class="login__tabs">
        <div class="login__tab" @click="activeTab = 'login'" :class="{'login__tab--active': activeTab === 'login'}">我是用户</div>
        <div class="login__tab" @click="activeTab = 'scan'" :class="{'login__tab--active': activeTab === 'scan'}">申请体验</div>
      </div>
      <div class="login__tabs-content">
        <div v-show="activeTab === 'login'" class="login__content">
          <section id="weixin-qrcode"></section>
          <div class="desc" style="transform: translateY(7px);">
            <img src="/img/wechat-logo.png" alt="">
            <span>使用微信扫一扫，登录iCourt法学院</span>
          </div>
        </div>
        <div v-show="activeTab === 'scan'" class="login__content">
          <img src="/img/nnd-qrcode.png" width="206" height="206" alt="">
          <div class="desc">
            <img src="/img/wechat-logo.png" alt="">
            <span>微信添加诺诺多，了解更多精彩课程</span>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'Login',
  data () {
    return {
      activeTab: 'login',
    }
  },
  computed: {
    ...mapState('app', ['isLogin']),
  },
  methods: {
  },
  mounted () {
    if (this.$router.currentRoute.query.verifyCode) {
      this.$router.replace({
        path: '/active-login',
        query: {
          verifyCode: this.$router.currentRoute.query.verifyCode,
        },
      })
      localStorage.setItem('verifyCode', this.$router.currentRoute.query.verifyCode)
    } else {
      if (this.isLogin) {
        this.$router.replace('/index')
      } else {
        this.$store.dispatch('app/weixinLogin')
      }
      localStorage.removeItem('verifyCode')
    }
  },
}
</script>

<style lang="scss" scoped>
.login {
  position: fixed;
  display: grid;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-image: url('/img/login-bg.png');
  background-repeat: no-repeat;
  background-size: cover;
  z-index: 1;
  main {
    place-self: center;
    width: 390px;
    height: 430px;
    background: #FFFFFF;
    box-shadow: 0px 8px 16px 0px rgba(68,76,82,0.04);
    border-radius: 10px;
    padding: 44px 0 64px;
    box-sizing: border-box;
    text-align: center;
  }

  &__tabs {
    display: flex;
    padding-inline: 94px;
    justify-content: space-between;
    margin-bottom: 32px;
  }
  &__tab {
    position: relative;
    width: 72px;
    font-size: 18px;
    font-weight: 400;
    color: #666666;
    padding-bottom: 8px;
    cursor: pointer;
    &--active {
      font-weight: 600;
      color: #171717;
      &::after {
        content: "";
        position: absolute;
        bottom: -4px;
        left: 50%;
        transform: translateX(-50%);
        width: 24px;
        height: 4px;
        background: #FA8919;
        border-radius: 2px;
      }
    }
  }
  &__tabs-content {
    #weixin-qrcode {
      width: 206px;
      height: 206px;
      margin-inline: auto;
    }
    .desc {
      margin-top: 24px;
      img {
        width: 20px;
        height: 20px;
        margin-right: 8px;
        vertical-align: sub;
      }
      span {
        font-size: 16px;
        color: #333333;
        line-height: 22px;
      }
    }
  }
}

#weixin-qrcode {
  /deep/ iframe {
    width: 206px;
    height: 206px;
  }
}
</style>
